<template>
	<div class="tab-page">
		<form @submit.prevent="save" ref="form">
			<div class="field">
				<div class="container">
					<div class="content">
						<div class="field-inner">
							<!-- <div class="title">{{$t('basic-information')}}</div> -->
							<label for="machine-type">{{$t('machine-type')}}</label>
							<div class="element">
								<div class="flex">
									<input type="text" placeholder=" " id="machine-type" v-model="$parent.newMachine.machineTypeName" readonly>
								</div>
							</div>
							<label for="name">{{$t('name')}}*</label>
							<div class="element">
								<div class="flex">
									<input type="text" placeholder=" " id="name" v-model="$parent.newMachine.name" required>
								</div>
							</div>
							<label for="spindles-number">{{$t('spindles-number')}}*</label>
							<div class="element">
								<div class="flex">
									<input type="text" placeholder=" " id="spindles-number" v-model="$parent.newMachine.spindlesNumber" readonly>
								</div>
							</div>
							<label for="serial-number">{{$t('serial-number')}}</label>
							<div class="element">
								<div class="flex">
									<input type="text" placeholder=" " id="serial-number" v-model="$parent.newMachine.serialNumber" readonly>
								</div>
							</div>
							<label for="code">{{$t('code')}}</label>
							<div class="element">
								<div class="flex">
									<input type="text" placeholder=" " id="code" v-model="$parent.newMachine.code" readonly>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr>
			<div class="container">
				<div class="content">
					<button>{{$t('save')}}</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	data() {
		return {
			saveError: false,
		}
	},
	methods: {
		save() {
			this.saveError = false;
			
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}

			if (this.$parent.machine.name === this.$parent.newMachine.name) {
				this.$snack.success({button: null, text: this.$t('nothing-to-save')});
				return;
			}

			if (!this.$parent.newMachine.name) {
				this.saveError = true;
				this.$snack.error({button: null, text: this.$t('compile-all-required-fields')});
				return;
			}

			if (!this.registrationError) {
				let params = new URLSearchParams();

				params.append('name', this.$parent.newMachine.name);

				let self = this;
				self.axios.put(`/machines/${self.$route.params.id}`, params)
				.then(() => {
					self.$snack.success({button: null, text: self.$t('saved-successfully')});
					self.$parent.machine = {...self.$parent.newMachine};
				})
				.catch((err) => {
					let resp = err.response;
					if (resp.data.response && resp.data.response.duplicate) {
						switch (resp.data.response.duplicate) {
							case 'name':
								self.$snack.danger({button: null, text: self.$t('duplicate-name-error')});
								break;
						}
					} else {
						self.$snack.danger({button: null, text: self.$t('save-error')});
					}
					self.saveError = true;
					if (navigator.vibrate){
						navigator.vibrate([500]);
					}
				});
			}
		}
	},
}
</script>